import { Show, TabbedForm, useRecordContext } from 'react-admin';
import PresentationDashboard from 'dashboard/PresentationDashboard';
import PresentationExcel from "excel_reporting/PresentationExcel";
import { useClientContext } from 'contexts/client';
import { Feature } from 'feature';
import WarehouseAssignments from "custom_components/WarehouseAssignment";

const styles = {
    dashboardWrapper: { display: "flex", width: "100%" },
    dashboardFeature: { flexGrow: 9 },
    excelFeature: { flexShrink: 3, maxWidth: 240 }
  };

const DashboardWrapper = () => {
    const { state: client } = useClientContext();
    const clientPrefix = client.client.resourcePrefix;
    const record = useRecordContext();

    if (!record){
      return (null)
    }
  
    return (
      <div style={styles.dashboardWrapper}>
        <Feature name="dashboard">
          <div style={styles.dashboardFeature}>
            <PresentationDashboard
              client={clientPrefix}
              deploy_target="warehouse"
              filter_by={record.primary_name}
              filter_field={`${clientPrefix}_warehouse@eq`}
            />
          </div>
        </Feature>
        <Feature name="excel">
          <div style={styles.excelFeature}>
            <PresentationExcel
              client={clientPrefix}
              deploy_target="warehouse"
              filter_by={record.primary_name}
              filter_field={`${clientPrefix}_warehouse`}
            />
          </div>
        </Feature>
      </div>
    )
  }

const DistributorShow = () => {    
    return (
        <Show>
            <TabbedForm>
                <TabbedForm.Tab label="Summary">
                    <DashboardWrapper />
                </TabbedForm.Tab>
                <TabbedForm.Tab label="Assignments">
                    <WarehouseAssignments />
                </TabbedForm.Tab>
            </TabbedForm>
        </Show>
    )
};

export default DistributorShow;

